module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.notificationsPage && _vm.notificationsPage.content) ? _c('div', {
    staticClass: "notifications-container"
  }, [_vm._l((_vm.notificationsPage.content), function(notification) {
    return _c('div', {
      key: notification.id,
      staticClass: "notification-card"
    }, [_c('div', {
      staticClass: "notification-card-title"
    }, [_c('h2', [_vm._v(" №" + _vm._s(notification.id) + " ")]), _vm._v(" "), _c('span', {
      staticClass: "notification-card-subject",
      class: _vm.getSubjectClass(notification.subject)
    }, [_vm._v(_vm._s(notification.subject))])]), _vm._v(" "), _c('div', {
      staticClass: "notification-card-details"
    }, [_c('div', {
      staticClass: "notification-card-details-item"
    }, [_vm._v("\n        " + _vm._s(notification.message) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "notification-card-details-item"
    }, [_vm._v("\n        Дата :\n        " + _vm._s(_vm.getDateFormat((notification.timestampInEpochMilli / 1000) < 1000000000000 ? notification.timestampInEpochMilli : notification.timestampInEpochMilli / 1000)) + "\n      ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "paging-bottom"
  }, [_c('Paging', {
    attrs: {
      "refresh": _vm.loadNotificationsPage,
      "per-page": _vm.perPage,
      "data": _vm.notificationsPage,
      "pagingClass": 'bottom'
    },
    on: {
      "update:data": function($event) {
        _vm.notificationsPage = $event
      }
    }
  })], 1)], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a710a62"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/billing/BillingNotifications.vue
// module id = 391
// module chunks = 42